import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    ViewEncapsulation,
} from '@angular/core';
import { AuthService } from './core/services/auth.service';

@Component({
    selector: 'solis-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.authService.populate();
        this.initializeSettings();
    }

    initializeSettings() {
        if (!window.localStorage.getItem('layout')) {
            window.localStorage.setItem('layout', 'grid');
        }

        if (!window.localStorage.getItem('fluid')) {
            window.localStorage.setItem('fluid', 'false');
        }

        if (!window.localStorage.getItem('limit')) {
            window.localStorage.setItem('limit', '10');
        }

        if (!window.localStorage.getItem('isNavbarOpen')) {
            window.localStorage.setItem('isNavbarOpen', 'false');
        }

        if (!window.localStorage.getItem('containerGiacenze')) {
            window.localStorage.setItem('containerGiacenze', 'completo');
        }
    }
}
